// import React, { useEffect, useRef, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import "./Navbar.css";

// export default function Navbar({ setBackgroundBlur }) {
//     const [activeNav, setActiveNav] = useState(null);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const menuRef = useRef(null);
//     const navigate = useNavigate();

//     const handleMouseOver = (index) => {
//         setActiveNav(index);
//         setBackgroundBlur(true); // Apply blur on mouseover
//     };

//     const handleMouseOut = () => {
//         setActiveNav(null);
//         setBackgroundBlur(false); // Remove blur on mouseout
//     };

//     const handleClickOutside = (event) => {
//         if (menuRef.current && !menuRef.current.contains(event.target)) {
//             setIsMenuOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     useEffect(() => {
//         // Close the menu when navigating to a new page
//         setIsMenuOpen(false);
//     }, [navigate]);

//     const navItems = [
//         {
//             title: "Training",
//             link: "/training",
//             subItems: [
//                 {}
//             ]
//         },
//         {
//             title: "Our Fleet",
//             link: "/our-fleet",
//             subItems: [
//                 {}
//             ]
//         },
//         {
//             title: "About Us",
//             link: "/about-us",
//             subItems: [
//                 {},
//             ]
//         },
//         {
//             title: "Contact Us",
//             link: "/contact-us",
//             subItems: [
//                 {}
//             ]
//         },
//     ];


//     return (
//         <nav className='bg-white px-4 py-3 md:px-10 max-md:py-1 sm:py-6 max-sm:py-6 xl:py-5 flex justify-center xl:justify-center sm:justify-start max-sm:justify-start items-center fixed w-full z-50'>
//             <div>
//                 <a href='/'>
//                     <img className='w-32 absolute top-4 left-10 xl:left-10 sm:left-5 max-sm:left-5' src='http://mhcockpit.com/Media/4%20Aviators/Logo/4_Aviators_Logo.png' alt='MH Cockpit Logo' loading='lazy' />
//                 </a>
//             </div>
//             <div>
//                 <div className='flex justify-between items-center'>
//                     <div className='md:block xl:hidden fixed top-3 right-3'>
//                         <button onClick={() => setIsMenuOpen(!isMenuOpen)} className='focus:outline-none'>
//                             <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
//                                 <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M4 6h16M4 12h16m-7 6h7'></path>
//                             </svg>
//                         </button>
//                     </div>
//                     <ul ref={menuRef} className={`space-x-14 xl:space-x-9 md:space-x-0 md:pt-5 sm:space-x-0 sm:pt-5 max-sm:space-x-0 max-sm:pt-5 lg:pt-5 xl:pt-0 ${isMenuOpen ? 'flex flex-col md:flex-col lg:flex max-md:flex max-lg:flex' : 'hidden sm:hidden md:hidden xl:flex'}`}>
//                         {navItems.map((item, index) => (
//                             <li
//                                 key={index}
//                                 className='heading md:relative'
//                                 onMouseOver={() => handleMouseOver(index)}
//                                 onMouseOut={handleMouseOut}
//                             >
//                                 <Link to={item.link} target={item.target} className='block py-2'>{item.title}</Link>
//                                 <ul className={`nav-list ${activeNav === index ? 'expanded space-y-2' : 'no_expand'}`}>
//                                     {item.subItems.map((subItem, subIndex) => (
//                                         <li key={subIndex} className='sub-1 max-sm:pl-5'>
//                                             <Link to={subItem.link}>{subItem.name}</Link>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>
//             <div>
//                 <button onClick={() => navigate('/contact')} className='bg-sky-500 font-semibold rounded-md absolute right-10 top-2 p-1 px-2 animate-pulse hover:scale-105 transition-transform duration-1000 ease-in-out'>Contact</button>
//             </div>
//         </nav>
//     );
// }




// import React, { useEffect, useRef, useState } from 'react';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import "./Navbar.css";

// export default function Navbar({ setBackgroundBlur }) {
//     const [activeNav, setActiveNav] = useState(null);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const menuRef = useRef(null);
//     const navigate = useNavigate();
//     const location = useLocation(); // 👈 To get current route path

//     const handleMouseOver = (index) => {
//         setActiveNav(index);
//         setBackgroundBlur(true);
//     };

//     const handleMouseOut = () => {
//         setActiveNav(null);
//         setBackgroundBlur(false);
//     };

//     const handleClickOutside = (event) => {
//         if (menuRef.current && !menuRef.current.contains(event.target)) {
//             setIsMenuOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     useEffect(() => {
//         setIsMenuOpen(false);
//     }, [navigate]);

//     const navItems = [
//         {
//             title: "Training",
//             link: "/training",
//             subItems: [{}],
//         },
//         {
//             title: "Our Fleet",
//             link: "/our-fleet",
//             subItems: [{}],
//         },
//         {
//             title: "About Us",
//             link: "/about-us",
//             subItems: [{}],
//         },
//         {
//             title: "Contact Us",
//             link: "/contact-us",
//             subItems: [{}],
//         },
//     ];

//     return (
//         <nav className="bg-white px-4 py-3 md:px-10 max-md:py-1 sm:py-6 max-sm:py-6 xl:py-5 flex justify-center xl:justify-center sm:justify-start max-sm:justify-start items-center fixed w-full z-50">
//             {/* Logo */}
//             <div>
//                 <a href="/">
//                     <img
//                         className="w-32 absolute top-4 left-10 xl:left-10 sm:left-5 max-sm:left-5"
//                         src="http://mhcockpit.com/Media/4%20Aviators/Logo/4_Aviators_Logo.png"
//                         alt="MH Cockpit Logo"
//                         loading="lazy"
//                     />
//                 </a>
//             </div>

//             {/* Menu */}
//             <div>
//                 <div className="flex justify-between items-center">
//                     {/* Mobile Toggle */}
//                     <div className="md:block xl:hidden fixed top-3 right-3">
//                         <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="focus:outline-none">
//                             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
//                             </svg>
//                         </button>
//                     </div>

//                     {/* Nav Items */}
//                     <ul
//                         ref={menuRef}
//                         className={`space-x-14 xl:space-x-9 md:space-x-0 md:pt-5 sm:space-x-0 sm:pt-5 max-sm:space-x-0 max-sm:pt-5 lg:pt-5 xl:pt-0 ${
//                             isMenuOpen ? 'flex flex-col md:flex-col lg:flex max-md:flex max-lg:flex' : 'hidden sm:hidden md:hidden xl:flex'
//                         }`}
//                     >
//                         {navItems.map((item, index) => {
//                             const isActive = location.pathname === item.link; // 👈 check if current route matches
//                             return (
//                                 <li
//                                     key={index}
//                                     className="heading md:relative"
//                                     onMouseOver={() => handleMouseOver(index)}
//                                     onMouseOut={handleMouseOut}
//                                 >
//                                     <Link
//                                         to={item.link}
//                                         target={item.target}
//                                         className={`block py-2 transition-colors duration-300 ${
//                                             isActive ? 'text-[#E43038] font-semibold' : 'text-gray-800 hover:text-[#E43038]'
//                                         }`}
//                                     >
//                                         {item.title}
//                                     </Link>

//                                     {/* Submenu */}
//                                     <ul className={`nav-list ${activeNav === index ? 'expanded space-y-2' : 'no_expand'}`}>
//                                         {item.subItems.map((subItem, subIndex) => (
//                                             <li key={subIndex} className="sub-1 max-sm:pl-5">
//                                                 <Link to={subItem.link}>{subItem.name}</Link>
//                                             </li>
//                                         ))}
//                                     </ul>
//                                 </li>
//                             );
//                         })}
//                     </ul>
//                 </div>
//             </div>

//             {/* Contact Button */}
//             <div>
//                 <button
//                     onClick={() => navigate('/contact')}
//                     className="bg-sky-500 font-semibold rounded-md absolute right-10 top-2 p-1 px-2 animate-pulse hover:scale-105 transition-transform duration-1000 ease-in-out"
//                 >
//                     Contact
//                 </button>
//             </div>
//         </nav>
//     );
// }



// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import "./Navbar.css";

// export default function Navbar({ setBackgroundBlur }) {
//     const [activeNav, setActiveNav] = useState(null);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const menuRef = useRef(null);
//     const navigate = useNavigate();
//     const location = useLocation();

//     const handleMouseOver = (index) => {
//         setActiveNav(index);
//         setBackgroundBlur(true);
//     };

//     const handleMouseOut = () => {
//         setActiveNav(null);
//         setBackgroundBlur(false);
//     };

//     const handleClickOutside = (event) => {
//         if (menuRef.current && !menuRef.current.contains(event.target)) {
//             setIsMenuOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, []);

//     useEffect(() => {
//         setIsMenuOpen(false);
//     }, [navigate]);

//     const navItems = [
//         { title: "Training", link: "/training" },
//         { title: "Our Fleet", link: "/our-fleet" },
//         { title: "About Us", link: "/about-us" },
//         { title: "Contact Us", link: "/contact-us" },
//     ];

//     return (
//         <nav className="fixed w-full bg-white/70 backdrop-blur-md z-50 px-6 md:px-10 py-4 flex justify-between items-center shadow-md transition-all duration-300">
//             {/* Logo */}
//             <a href="/" className="flex items-center gap-2">
//                 <img
//                     className="w-28 sm:w-32 transition-transform duration-500 hover:scale-105"
//                     src="http://mhcockpit.com/Media/4%20Aviators/Logo/4_Aviators_Logo.png"
//                     alt="MH Cockpit Logo"
//                     loading="lazy"
//                 />
//             </a>

//             {/* Mobile Toggle */}
//             <div className="xl:hidden z-50">
//                 <button
//                     aria-label="Toggle menu"
//                     onClick={() => setIsMenuOpen((prev) => !prev)} // ✅ toggle correctly
//                     className="text-gray-700 focus:outline-none transition-transform duration-300 hover:scale-110"
//                 >
//                     {isMenuOpen ? (
//                         // ✖ Close icon (animated)
//                         <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="w-7 h-7 transition-transform duration-300 rotate-90"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M6 18L18 6M6 6l12 12"
//                             />
//                         </svg>
//                     ) : (
//                         // ☰ Menu icon (animated)
//                         <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="w-7 h-7 transition-transform duration-300"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M4 6h16M4 12h16m0 6H4"
//                             />
//                         </svg>
//                     )}
//                 </button>
//             </div>

//             {/* Desktop Menu */}
//             <ul
//                 ref={menuRef}
//                 className={`hidden xl:flex items-center gap-12 transition-all duration-500`}
//             >
//                 {navItems.map((item, index) => {
//                     const isActive = location.pathname === item.link;
//                     return (
//                         <motion.li
//                             key={index}
//                             onMouseOver={() => handleMouseOver(index)}
//                             onMouseOut={handleMouseOut}
//                             initial={{ opacity: 0, y: -10 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: index * 0.1 }}
//                             className="relative group"
//                         >
//                             <Link
//                                 to={item.link}
//                                 className={`text-lg font-medium transition-all duration-300 ${isActive
//                                         ? "text-[#E43038]"
//                                         : "text-gray-800 hover:text-[#E43038]"
//                                     }`}
//                             >
//                                 {item.title}
//                                 {/* Active/hover underline animation */}
//                                 <span
//                                     className={`absolute left-0 bottom-[-4px] h-[2px] w-0 bg-gradient-to-r from-[#E43038] to-[#ff6b6b] transition-all duration-300 group-hover:w-full ${isActive ? "w-full" : "w-0"
//                                         }`}
//                                 ></span>
//                             </Link>
//                         </motion.li>
//                     );
//                 })}
//             </ul>

//             {/* Contact Button */}
//             <motion.button
//                 onClick={() => navigate("/contact")}
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="hidden xl:block bg-gradient-to-r from-[#E43038] to-[#ff6b6b] text-white font-semibold rounded-lg px-5 py-2 shadow-lg transition-transform duration-300"
//             >
//                 Contact
//             </motion.button>

//             {/* Mobile Menu Animation */}
//             <AnimatePresence>
//                 {isMenuOpen && (
//                     <motion.div
//                         initial={{ opacity: 0, y: -20 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: -20 }}
//                         transition={{ duration: 0.3 }}
//                         className="absolute top-16 left-0 w-full bg-white shadow-lg xl:hidden z-40"
//                     >
//                         <ul className="flex flex-col items-center py-4 space-y-4">
//                             {navItems.map((item, index) => {
//                                 const isActive = location.pathname === item.link;
//                                 return (
//                                     <motion.li
//                                         key={index}
//                                         whileHover={{ scale: 1.05 }}
//                                         transition={{ duration: 0.2 }}
//                                     >
//                                         <Link
//                                             to={item.link}
//                                             onClick={() => setIsMenuOpen(false)}
//                                             className={`block text-lg font-medium ${isActive
//                                                     ? "text-[#E43038]"
//                                                     : "text-gray-800 hover:text-[#E43038]"
//                                                 }`}
//                                         >
//                                             {item.title}
//                                         </Link>
//                                     </motion.li>
//                                 );
//                             })}
//                             <motion.button
//                                 onClick={() => {
//                                     navigate("/contact");
//                                     setIsMenuOpen(false);
//                                 }}
//                                 whileHover={{ scale: 1.05 }}
//                                 className="bg-gradient-to-r from-[#E43038] to-[#ff6b6b] text-white font-semibold rounded-lg px-5 py-2 shadow-lg"
//                             >
//                                 Contact
//                             </motion.button>
//                         </ul>
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </nav>
//     );
// }




// import React, { useEffect, useRef, useState } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import "./Navbar.css";

// export default function Navbar({ setBackgroundBlur }) {
//     const [activeNav, setActiveNav] = useState(null);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const menuRef = useRef(null);
//     const navigate = useNavigate();
//     const location = useLocation();

//     // Handle hover blur effects
//     const handleMouseOver = (index) => {
//         setActiveNav(index);
//         setBackgroundBlur(true);
//     };

//     const handleMouseOut = () => {
//         setActiveNav(null);
//         setBackgroundBlur(false);
//     };

//     // Close menu when clicking outside
//     const handleClickOutside = (event) => {
//         if (menuRef.current && !menuRef.current.contains(event.target)) {
//             setIsMenuOpen(false);
//         }
//     };

//     useEffect(() => {
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, []);

//     // ✅ Close menu when route changes
//     useEffect(() => {
//         setIsMenuOpen(false);
//     }, [location.pathname]);

//     const navItems = [
//         { title: "Training", link: "/training" },
//         { title: "Our Fleet", link: "/our-fleet" },
//         { title: "About Us", link: "/about-us" },
//         { title: "Contact Us", link: "/contact-us" },
//     ];

//     return (
//         <nav className="fixed w-full bg-white/70 backdrop-blur-md z-50 px-6 md:px-10 py-4 flex justify-between items-center shadow-md transition-all duration-300">
//             {/* Logo */}
//             <Link to="/" className="flex items-center gap-2">
//                 <img
//                     className="w-28 sm:w-32 transition-transform duration-500 hover:scale-105"
//                     src="http://mhcockpit.com/Media/4%20Aviators/Logo/4_Aviators_Logo.png"
//                     alt="MH Cockpit Logo"
//                     loading="lazy"
//                 />
//             </Link>

//             {/* Mobile Toggle */}
//             <div className="xl:hidden z-50">
//                 <button
//                     aria-label="Toggle menu"
//                     onClick={() => setIsMenuOpen((prev) => !prev)} // ✅ toggles open/close correctly
//                     className="text-gray-700 focus:outline-none transition-transform duration-300 hover:scale-110"
//                 >
//                     {isMenuOpen ? (
//                         // ✖ Close icon
//                         <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="w-7 h-7 transition-transform duration-300 rotate-90"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M6 18L18 6M6 6l12 12"
//                             />
//                         </svg>
//                     ) : (
//                         // ☰ Menu icon
//                         <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             className="w-7 h-7 transition-transform duration-300"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                         >
//                             <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M4 6h16M4 12h16m0 6H4"
//                             />
//                         </svg>
//                     )}
//                 </button>
//             </div>

//             {/* Desktop Menu */}
//             <ul
//                 ref={menuRef}
//                 className={`hidden xl:flex items-center gap-12 transition-all duration-500`}
//             >
//                 {navItems.map((item, index) => {
//                     const isActive = location.pathname === item.link;
//                     return (
//                         <motion.li
//                             key={index}
//                             onMouseOver={() => handleMouseOver(index)}
//                             onMouseOut={handleMouseOut}
//                             initial={{ opacity: 0, y: -10 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: index * 0.1 }}
//                             className="relative group"
//                         >
//                             <Link
//                                 to={item.link}
//                                 className={`text-lg font-medium transition-all duration-300 ${
//                                     isActive
//                                         ? "text-[#E43038]"
//                                         : "text-gray-800 hover:text-[#E43038]"
//                                 }`}
//                             >
//                                 {item.title}
//                                 {/* Underline animation */}
//                                 <span
//                                     className={`absolute left-0 bottom-[-4px] h-[2px] bg-gradient-to-r from-[#E43038] to-[#ff6b6b] transition-all duration-300 ${
//                                         isActive
//                                             ? "w-full"
//                                             : "w-0 group-hover:w-full"
//                                     }`}
//                                 ></span>
//                             </Link>
//                         </motion.li>
//                     );
//                 })}
//             </ul>

//             {/* Contact Button */}
//             <motion.button
//                 onClick={() => navigate("/contact")}
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className="hidden xl:block bg-gradient-to-r from-[#E43038] to-[#ff6b6b] text-white font-semibold rounded-lg px-5 py-2 shadow-lg transition-transform duration-300"
//             >
//                 Contact
//             </motion.button>

//             {/* Mobile Menu Animation */}
//             <AnimatePresence>
//                 {isMenuOpen && (
//                     <motion.div
//                         initial={{ opacity: 0, y: -20 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: -20 }}
//                         transition={{ duration: 0.3 }}
//                         className="absolute top-16 left-0 w-full bg-white shadow-lg xl:hidden z-40"
//                     >
//                         <ul className="flex flex-col items-center py-4 space-y-4">
//                             {navItems.map((item, index) => {
//                                 const isActive = location.pathname === item.link;
//                                 return (
//                                     <motion.li
//                                         key={index}
//                                         whileHover={{ scale: 1.05 }}
//                                         transition={{ duration: 0.2 }}
//                                     >
//                                         <Link
//                                             to={item.link}
//                                             onClick={() => setIsMenuOpen(false)}
//                                             className={`block text-lg font-medium ${
//                                                 isActive
//                                                     ? "text-[#E43038]"
//                                                     : "text-gray-800 hover:text-[#E43038]"
//                                             }`}
//                                         >
//                                             {item.title}
//                                         </Link>
//                                     </motion.li>
//                                 );
//                             })}
//                             <motion.button
//                                 onClick={() => {
//                                     navigate("/contact");
//                                     setIsMenuOpen(false);
//                                 }}
//                                 whileHover={{ scale: 1.05 }}
//                                 className="bg-gradient-to-r from-[#E43038] to-[#ff6b6b] text-white font-semibold rounded-lg px-5 py-2 shadow-lg"
//                             >
//                                 Contact
//                             </motion.button>
//                         </ul>
//                     </motion.div>
//                 )}
//             </AnimatePresence>
//         </nav>
//     );
// }






import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Navbar.css";

export default function Navbar({ setBackgroundBlur }) {
    const [activeNav, setActiveNav] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    // Hover effects for desktop blur
    const handleMouseOver = (index) => {
        setActiveNav(index);
        setBackgroundBlur(true);
    };

    const handleMouseOut = () => {
        setActiveNav(null);
        setBackgroundBlur(false);
    };

    // ✅ Close mobile menu if clicked outside of BOTH menu and toggle
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            // Don’t close if toggle button is clicked
            if (!event.target.closest("#mobile-toggle-btn")) {
                setIsMenuOpen(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // ✅ Close menu when route changes
    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    const navItems = [
        { title: "Training", link: "/training" },
        { title: "Our Fleet", link: "/our-fleet" },
        { title: "About Us", link: "/about-us" },
        { title: "Contact Us", link: "/contact-us" },
    ];

    return (
        <nav className="fixed w-full bg-white/70 backdrop-blur-md z-50 px-6 md:px-10 py-4 flex justify-between items-center shadow-md transition-all duration-300">
    {/* Logo */}
    <Link to="/" className="flex items-center gap-2">
      <img
        className="w-28 sm:w-32 transition-transform duration-500 hover:scale-105"
        src="http://mhcockpit.com/Media/4%20Aviators/Logo/4_Aviators_Logo.png"
        alt="MH Cockpit Logo"
        loading="lazy"
      />
    </Link>

    {/* ✅ Right section: Register + Toggle */}
    <div className="flex items-center gap-4 xl:hidden z-50">
      {/* Register button for mobile */}
      <motion.button
        onClick={() => navigate("/contact-us")}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-gradient-to-r from-[#E43038] to-[#ff6b6b] text-white font-semibold rounded-md px-4 py-1.5 shadow-md text-sm sm:text-base transition-transform duration-300"
      >
        Register
      </motion.button>

      {/* Mobile Toggle */}
      <button
        id="mobile-toggle-btn"
        aria-label="Toggle menu"
        onClick={() => setIsMenuOpen((prev) => !prev)}
        className="text-gray-700 focus:outline-none transition-transform duration-300 hover:scale-110"
      >
        {isMenuOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-7 h-7 transition-transform duration-300 rotate-90"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-7 h-7 transition-transform duration-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m0 6H4"
            />
          </svg>
        )}
      </button>
    </div>

    {/* Desktop Menu */}
    <ul
      ref={menuRef}
      className={`hidden xl:flex items-center gap-12 transition-all duration-500`}
    >
      {navItems.map((item, index) => {
        const isActive = location.pathname === item.link;
        return (
          <motion.li
            key={index}
            onMouseOver={() => handleMouseOver(index)}
            onMouseOut={handleMouseOut}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="relative group"
          >
            <Link
              to={item.link}
              className={`text-lg font-medium transition-all duration-300 ${
                isActive
                  ? "text-[#E43038]"
                  : "text-gray-800 hover:text-[#E43038]"
              }`}
            >
              {item.title}
              <span
                className={`absolute left-0 bottom-[-4px] h-[2px] bg-gradient-to-r from-[#E43038] to-[#ff6b6b] transition-all duration-300 ${
                  isActive ? "w-full" : "w-0 group-hover:w-full"
                }`}
              ></span>
            </Link>
          </motion.li>
        );
      })}
    </ul>

    {/* ✅ Desktop Register Button */}
    <motion.button
      onClick={() => navigate("/contact-us")}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="hidden xl:block bg-gradient-to-r from-[#E43038] to-[#ff6b6b] text-white font-semibold rounded-lg px-5 py-2 shadow-lg transition-transform duration-300"
    >
      Register
    </motion.button>

    {/* Mobile Menu Animation */}
    <AnimatePresence>
      {isMenuOpen && (
        <motion.div
          ref={menuRef}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="absolute top-16 left-0 w-full bg-white shadow-lg xl:hidden z-40"
        >
          <ul className="flex flex-col items-center py-4 space-y-4">
            {navItems.map((item, index) => {
              const isActive = location.pathname === item.link;
              return (
                <motion.li
                  key={index}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.2 }}
                >
                  <Link
                    to={item.link}
                    onClick={() => setIsMenuOpen(false)}
                    className={`block text-lg font-medium ${
                      isActive
                        ? "text-[#E43038]"
                        : "text-gray-800 hover:text-[#E43038]"
                    }`}
                  >
                    {item.title}
                  </Link>
                </motion.li>
              );
            })}
          </ul>
        </motion.div>
      )}
    </AnimatePresence>
  </nav>
    );
}
